import { QUERY_KEYS } from '../../../../consts';
import { getIsMobileRegisteredService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const getIsMobileRegisteredAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.GET_MOBILE_IS_REGISTERED,
  mutationFn: () => getIsMobileRegisteredService,
});
